module.exports = __webpack_public_path__ + "img/LEXUS.f8e9151.jpg";